<template>
    <div v-loading='loading' class="page page-home" :style="'background-image: url('+actInfo.bgImg+');background-color:'+bgColor+' '">
        <router-link  to="/chou_jiang_ji_lu" class="btn btn-choujiangjilu">抽奖记录</router-link>
        <router-link  :to="'/gui_ze?pic=' + actInfo.ruleImg" class="btn btn-rule">活动规则</router-link>
        <router-link  to="/chou_jiang" class="btn btn-chouhaoli">抽豪礼</router-link>
        <router-link  to="/pai_hang_bang" class="btn btn-paihangbang">排行榜</router-link>
        <div class="userinfo pa">
            <img :src="userInfo.avatar || default_user" alt="" class="pic pa">
            <div class="line1 pa">用户名: {{userInfo.nickName}}</div>
            <div class="line2 pa to">等级: <i style="padding-right: 5px">{{userInfo.levelName}}</i> 分数: <i>{{userInfo.score}}</i></div>
        </div>
        <div class="da-ti" @click="onDati"></div>
        
        <div class="da-ti-num pa">剩余答题次数：{{daTiNum}}次</div>
        <div class="list">
            <div class="list-item  list-item-2 clearfix" v-if="fromPlat != 1">
                <img class="el pic" src="@/assets/image/home-btn-share.png" alt="">
                <div class="el desc">分享活动，+1抽奖次数</div>
                <div class="el btnss to" @click="onShare">分享</div>
            </div>
            <div class="list-item list-item-2 clearfix" v-if="fromPlat != 1">
                <img class="el pic" src="@/assets/image/home-btn-share.png" alt="">
                <div class="el desc" v-if="fromPlat != 1">成功邀请一位好友参与活动，+5分</div>
                <div class="el desc" v-else>邀请好友参与活动</div>
                <div class="el btnss to" @click="onShare">邀请</div>
            </div>
            <div class="list-item clearfix" v-for="(item,index) in actInfo && actInfo.taskList" :key='index'>
                <img class="el pic" :src="item.icon || default_icon" alt="">
                <div class="el desc">{{item && item.text}}</div>
                <div class="el btnss to" @click="onGoTo(item && item.link,item && item.taskId)">{{item && item.btnText}}</div>
            </div>
        </div>
        
        <!-- 成功邀请提示 -->
        <el-dialog
            :visible.sync="dialogYaoqing"
            width="80%"
            custom-class='el-dialog-no-header'
        >
            <div class="pop-yaoqing-line1">已成功邀请{{userInfo.addCount}}位好友</div>
            <div class="pop-yaoqing-line2"><span>+{{userInfo.addScore}}</span>分</div>
            <br/>
            <div class="button" @click="dialogYaoqing = false">再接再厉，大奖等你拿</div>
        </el-dialog>
        <!-- 登陆 -->
        <el-dialog
            :visible.sync="dialogLogin"
            width="80%"
            :close-on-click-modal="false"
            custom-class='el-dialog-no-header'
            :show-close="false"
        >
            <el-row>
              <el-col  :span="5" style="text-align: center" class="code-btn">账号:</el-col>
              <el-col  :span="19">
                    <!-- <el-input class="inp code" v-model="phone"></el-input> -->
                    <div class="inp-box">
                        <input type="text" placeholder="请填写手机号码" v-model="phone" />
                    </div>
              </el-col>
            </el-row>
            <br/>
            <el-row>
              <el-col  :span="5" style="text-align: center" class="code-btn">密码:</el-col>
              <el-col  :span="19">
                    <div class="inp-box">
                        <input type="password" placeholder="请填写6-8位密码" maxlength="8" @input='onInput' v-model="pwd" />
                    </div>
              </el-col>
            </el-row>
            <br/>
            <div :class="'button ' + (canSubmitLogin?'':'disabled')" @click="onLogin">登 录</div>
            <a :href="registerLink" class="register">还没有账户？去注册</a>
        </el-dialog>
        <!-- 即将进入答题 -->
        <el-dialog
            :visible.sync="dialogDatiTip"
            width="80%"
            custom-class='el-dialog-no-header'
            :show-close="showCloseBtn"
        >
            <div class="tip-text">提交成功，即将进入答题{{time3s}}s</div>
        </el-dialog>
        <!-- 没有答题次数了 -->
        <el-dialog
            :visible.sync="dialogDatiTipNo"
            width="80%"
            custom-class='el-dialog-no-header'
            :show-close="true"
        >
            <div class="tip-text">您没有答题次数了，先做任务吧！</div>
            <br />
            <div class="button" @click="dialogDatiTipNo = false">知道啦</div>
        </el-dialog>
        <!-- 活动未开始 -->
        <el-dialog
            :visible.sync="dialogActiveNo"
            width="80%"
            custom-class='el-dialog-no-header'
            :show-close="true"
        >
            <div class="tip-text">活动还未开始</div>
            <br/>
            <div class="button">知道啦</div>
        </el-dialog>
        <share ref="share"/>
        
    </div>

</template>

<script>

    import api from '@/assets/js/api'
    import appENV from '@/assets/js/env'
    import { cookie} from '@/assets/js/utils'
    import Share from '../share.vue'
    export default {
        name: "notice",
        data() {
            return {
                actId: 1,
                canSubmitLogin: true,
                loading: false,
                registerLink: '',
                showCloseBtn: false,// 弹窗-显示关闭按钮
                dialogDatiTipNo: false, // 没有答题次数了
                dialogLogin: false, // 弹窗-登陆
                dialogDatiTip: false,// 弹窗-开始答题提示
                dialogYaoqing: false,// 弹窗-邀请
                dialogActiveNo: false, // 弹窗-活动未开始
                userInfo: {},
                default_icon: require('../../assets/image/home-btn-ji.png'),
                default_user: require('../../assets/image/default_user.png'),
                bgColor: "#cd4a3b",
                daTiNum: 1,// 剩余答题次数
                time3s: 3, // 进入答题倒计时
                phone: '',
                pwd: '',
                actInfo: [],
                fromPlat: 0,
                query: this.$route.query
            }
        },

        activated(){
            self.onGetUserinfo();
        },

        watch: {
            $route(to, from){
                this.onGetUserinfo()
            }
        },

        methods: {
            onInput(){
                // if(this.pwd.length >=8){
                //     this.$message({
                //         message: '密码最长8位'
                //     })
                // }
            },
            // 页面加载
            async onload(){
                let self = this;
                self.checkRegisterCbk() // 检测是否为注册成功回调，进行处理
                self.onGetTask();
                self.onGetUserinfo();
                
                self.fromPlat = await appENV.catch(err => {
                    // console.log(err)
                })
                // 处理注册地址
                self.headleRegisterLink();

                // 中行
                if(self.fromPlat == 2){
                    self.onZhonghangReload();
                }

                let idx=location.href.indexOf('?');
                if(idx>0){
                    let query = location.href.substr(idx);
                    // 用户如果携带query参数进入页面，则将其query参数整个字符串保存在cookie中，随浏览器关闭失效
                    if(query&&query.length>1){
                        cookie.set('query'+ self.actId, query)
                    }
                }

                
                
            },
            // 检测是否为注册成功回调，进行处理
            async checkRegisterCbk(){// mobile 和 custId
                let self = this;
                let token = cookie.get('token'+self.actId);
                if(token){//已登录不处理
                    return;
                }
                if(self.$route.query && self.$route.query.mobile && self.$route.query.custId){
                    let res = await api({
                        method: 'getToken',
                        mobile: self.query && self.query.mobile,
                        custId: self.query && self.query.custId,
                        fromSource: cookie.get('query'+self.actId) || '',
                    }).catch(err => {
                        // console.log(err)
                    })
                    let {data, code ,msg} = res && res.data;
                    // console.log(data, code ,msg)
                    // hasReward
                    if(code ==200){
                        self.shareKey = data.shareKey;
                        cookie.set('token'+self.actId, data.token, 365);
                        cookie.set('shareKey'+self.actId, data.shareKey, 365);
                        let t = setTimeout(()=>{
                            clearTimeout(t);
                            self.onGetUserinfo();
                        }, 50)
                        self.dialogLogin = false;
                    }
                    if(code == 199){
                        self.onShowLoginPop();
                    }
                    
                    
                }
            },
            
            // 处理注册地址，注意微信和app内运行链接不同
            async headleRegisterLink(){
                this.fromPlat = await appENV.catch(err => {
                    // console.log(err)
                })
                // let link = 'https://m.bocim.com/zyfund_temp/zy/index.html#/register?type=otherActivity&notifyUrl='; //准生产环境
                var link='';
                if(this.fromPlat == 1){ //微信内
                    link = 'https://m.bocim.com/zyfund/zy/index.html#/register?type=otherActivity&notifyUrl=';   //微信渠道用这个链接
                }else{ //app内
                    link = 'https://m.bocim.com/zyfund/zy/index.html#/app/register?type=otherActivity&notifyUrl=';   //app渠道用这个链接
                }
                this.registerLink = link + encodeURI(location.href);
            },

            // 中行app中，如果当前用户已登录(token已存在)并且url未携带分享参数
            // 或者携带的分享参数和当前登录用户保存在本地的 shareKey 不同，
            // 则将页面地址重置为 活动首页地址 + 当前用户shareKey
            onZhonghangReload(){

                let self = this;
                let token = cookie.get('token'+self.actId);
                if(!token){
                    self.onShowLoginPop();
                    return;
                }
                if(self.$route && self.$route.query && self.$route.query.__sk 
                    && self.$route.query.__fok && self.$route.query.__sa ){
                    let urlShareKey = '?__sk='+self.$route.query.__sk
                                        +'&__fok='+self.$route.query.__fok
                                        +'&__sa='+self.$route.query.__sa;
                    let shareKey = cookie.get('shareKey'+self.actId);
                    if(urlShareKey !== shareKey){
                        location.href = self.$refs['share'].getShareUrl();
                    }
                }else{
                    location.href = self.$refs['share'].getShareUrl();
                }                
            },

            // 任务列表，点击跳转
            async onGoTo(link, taskId = 1){
                if(!taskId){
                    return;
                }
                let self = this;
                let token = cookie.get('token'+self.actId);
                if(!token){
                    self.onShowLoginPop();
                    return;
                }
                self.loading = true;
                let res = await api({
                    method: 'finishTask',
                    token,
                    taskId
                }).catch(err => {
                    // console.log(err)
                    self.loading = false;

                })
                let {data, code ,msg} = res && res.data;
                // console.log(data, code ,msg)
                // hasReward
                if(code ==200){
                    // if(data.hasReward){
                    self.loading = false;
                    //  .jpg .png .gif
                    // link = 'https://fanyi.baidu.com/static/webpage/img/download/pcV2/1.png'
                    if(link.includes('.jpeg') || link.includes('.png')||link.includes('.jpg')||link.includes('.gif')){
                        self.$router.push('/gui_ze?pic=' + link)
                    }else{
                        window.location.href = link
                    }
                    
                    // }
                }
                self.loading = false;
            },

            // 获取任务列表
            async onGetTask(){
                let self = this;
               
                let res = await api({
                    method: 'actTask',
                    // token
                }).catch(err => {
                    // console.log(err)
                })
                let {data, code ,msg} = res && res.data;
                // console.log(data, code ,msg)
                if(code ==200){
                    self.actInfo = data;
                }
                self.dialogActiveNo = code == 685 || code == 686 || code == 687
            },

            onDati(){
                let self = this;
                if(this.userInfo.nickName){
                    
                    api({
                        method: 'canAnswerCount'
                    })
                    .then(res => {
                        let {data, code } = res && res.data;
                        // console.log(data)
                        if(code == 200){
                            self.daTiNum = data.canAnswerCount;
                            if(data.canAnswerCount<= 0){
                                self.dialogDatiTipNo = true;
                            }else{
                                self.$router.push('/da_ti');
                            }
                        }else{
                            self.$router.push('/da_ti');
                        }
                    })
                    .catch(err => {
                        // console.log(err)
                        self.$router.push('/da_ti');
                    })
                    
                }
            },

            // 显示登陆弹窗
            onShowLoginPop(){
                this.dialogLogin = true;
            },

            // 登陆
            async onLogin(){
                let self = this;
                // self.loading = true;
                if(!self.canSubmitLogin){
                    return;
                } // 防止重复提交
                if(!(self.phone && self.pwd)){
                    self.$message({
                        message: '请输入正确的账号信息'
                    })
                    return;
                }
                self.canSubmitLogin = false;
                let res = await api({
                    method: 'login',
                    mobile: self.phone,
                    fromSource: cookie.get('query'+self.actId) || '',
                    pwd: self.pwd
                }).catch(err => {
                    // console.log(err)
                    self.canSubmitLogin = true;

                })
                let ttt = setTimeout(()=>{
                    clearTimeout(ttt);
                    self.canSubmitLogin = true;
                }, 500)
                let {data, code ,msg} = res && res.data;
                // console.log(data, code ,msg)
                if(code ==200 && data.token){
                    self.shareKey = data.shareKey;
                    cookie.set('token'+self.actId, data.token, 365);
                    cookie.set('shareKey'+self.actId, data.shareKey, 365);
                    
                    self.$message({
                        type: 'success',
                        message: msg || '登陆成功'
                    })
                    self.dialogLogin = false;
                    // self.onGoToDati(); // 即将答题提示弹窗
                    let t = setTimeout(()=>{
                        clearTimeout(t);
                        self.onGetUserinfo();
                    }, 1000)
                    
                }else{
                    self.$message({
                        type: 'error',
                        message: msg || '登陆失败'
                    })
                }
                // self.loading = false;

                
            },

            // 获取用户信息
            async onGetUserinfo(){
                let self = this;

                let token = cookie.get('token'+self.actId);
                // alert(self.actId)
                if(!token){
                    self.onShowLoginPop();
                    return;
                }
                if(self.userInfo && self.userInfo.nickName){
                    // return self.userInfo;
                }
                // self.loading = true;
                let res = await api({
                    token,
                    method: 'userInfo'
                }).catch(err => {
                    // console.log(err)
                })
                let {data, code ,msg} = res && res.data;
                // console.log(data, code ,msg)
                // addCount  邀请成功增加人数 、addScore 增加分数、 canRunCount 剩余可抽奖次数  、canAnswerCount 剩余答题次数
                if(code ==200){
                    self.daTiNum = data.canAnswerCount;
                    self.userInfo = data;
                    self.dialogYaoqing = data.addCount;

                }
                // self.loading = false;
            },
            // 3s后跳转答题页面 提示弹窗
            onGoToDati(){
                this.dialogDatiTip = true;
                let self = this;
                let tt = 3;
                let t = setInterval(function(){
                    tt--;
                    if(tt == 0){
                        clearInterval(t);
                        
                        self.$router.push('da_ti');
                    }
                    self.time3s = tt;
                    

                }, 1000)
            },
            /** 
             * 封装分享包含微信、中银
            */
            onShare(){
                this.$refs['share'].share()
            },

            goBack(){
                this.onGetUserinfo();
                //replace替换原路由，作用是避免回退死循环
            }

            
            
        },
        created(){
        },

        destroyed(){
            let self = this;
            window.removeEventListener('popstate', self.goBack, false);
        },
        mounted() {
            let self = this;
            self.actId = (self.query && self.query.__sa) || 1;
            this.onload();
            // setInterval(function(){
            //     console.log(3333)
            //     self.onGetUserinfo()
            // }, 3000)
            
            this.$refs['share'].init();
            if(this.$route.query && this.$route.query.logout){
                cookie.set('shareKey'+self.actId, '', -1);
                cookie.set('token'+self.actId, '', -1);
                this.$message({
                    message: '已经退出登陆'
                })
                location.href = location.href.substr(0,location.href.indexOf('?'))
            }

            if (window.history && window.history.pushState) {
                history.pushState(null, null, document.URL);
                window.addEventListener('popstate', self.goBack, false);
            }
        },
        components:{
            Share
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import './index.less';
</style>